import ReactImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './PhotoGalery3.css';
import Img1 from '../assets/gallery/1.jpg';
import Img2 from '../assets/gallery/2.jpg';
import Img3 from '../assets/gallery/3.jpg';
import Img4 from '../assets/gallery/4.jpg';
import Img5 from '../assets/gallery/5.jpg';
import Img6 from '../assets/gallery/6.jpg';
import Img7 from '../assets/gallery/7.jpg';
import Img8 from '../assets/gallery/8.jpg';
import Img9 from '../assets/gallery/9.jpg';
import Img10 from '../assets/gallery/10.jpg';

const PhotoGalery3 = () => {
    const imgs = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9, Img10];
    const images = imgs.map((img) => ({ original: img }));

    return (
        <div className="section photo-galery-section">
            <div className="cursive-left">
                <h1 className="cursive cDark">The best love</h1>
                <h1 className="cursive cDark">stories never end</h1>
            </div>
            <div className="image-gallery">
                <ReactImageGallery
                    items={images}
                    showNav={false}
                    showThumbnails={false}
                    autoPlay={true}
                    showPlayButton={false}
                    showFullscreenButton={false}
                />
            </div>

            <div className="cursive-right">
                <h1 className="cursive cDark">this is just</h1>
                <h1 className="cursive cDark">the beginning</h1>
            </div>
        </div>
    );
};

export default PhotoGalery3;
